import Vue from 'vue'
import format from './format'
import constants from './constants'

// 金额格式化
Vue.filter('money', (value, currency = '¥', decimals = 2) => {
  return format.formatMoney(value, currency, decimals)
})

// 数字格式化（千位分隔）
Vue.filter('number', (value, decimals = 0) => {
  return format.formatNumber(value, decimals)
})

// 百分比格式化
Vue.filter('percent', (value, decimals = 2) => {
  return format.formatPercent(value, decimals)
})

// 日期格式化
Vue.filter('date', (value, formatStr = 'YYYY-MM-DD') => {
  return format.formatDate(value, formatStr)
})

// 时间格式化
Vue.filter('datetime', (value, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
  return format.formatDateTime(value, formatStr)
})

// 相对时间
Vue.filter('relativeTime', (value) => {
  return format.formatRelativeTime(value)
})

// 文件大小格式化
Vue.filter('fileSize', (value, decimals = 2) => {
  return format.formatFileSize(value, decimals)
})

// 时长格式化
Vue.filter('duration', (value) => {
  return format.formatDuration(value)
})

// 手机号脱敏
Vue.filter('phone', (value) => {
  return format.formatPhone(value)
})

// 身份证脱敏
Vue.filter('idCard', (value) => {
  return format.formatIdCard(value)
})

// 银行卡脱敏
Vue.filter('bankCard', (value) => {
  return format.formatBankCard(value)
})

// 姓名脱敏
Vue.filter('name', (value) => {
  return format.formatName(value)
})

// 地址截断
Vue.filter('address', (value, length = 10) => {
  return format.formatAddress(value, length)
})

// 作品状态转换
Vue.filter('workStatus', (value, type = 'label') => {
  const status = Object.values(constants.WORK_STATUS).find(s => s.value === value)
  return status ? status[type] : value
})

// 收益类型转换
Vue.filter('earningType', (value, type = 'label') => {
  const earningType = Object.values(constants.EARNING_TYPE).find(e => e.value === value)
  return earningType ? earningType[type] : value
})

// 收益状态转换
Vue.filter('earningStatus', (value, type = 'label') => {
  const status = Object.values(constants.EARNING_STATUS).find(s => s.value === value)
  return status ? status[type] : value
})

// 提现状态转换
Vue.filter('withdrawStatus', (value, type = 'label') => {
  const status = Object.values(constants.WITHDRAW_STATUS).find(s => s.value === value)
  return status ? status[type] : value
})

// 消息类型转换
Vue.filter('messageType', (value, type = 'label') => {
  const msgType = Object.values(constants.MESSAGE_TYPE).find(m => m.value === value)
  return msgType ? msgType[type] : value
})

// 分类名称
Vue.filter('categoryName', (value) => {
  const category = constants.WORK_CATEGORIES.find(c => c.value === value)
  return category ? category.label : value
})

// 解锁方式
Vue.filter('unlockType', (value, type = 'label') => {
  const unlock = Object.values(constants.UNLOCK_TYPES).find(u => u.value === value)
  return unlock ? unlock[type] : value
})

// 截断文本
Vue.filter('truncate', (value, length = 20, suffix = '...') => {
  if (!value) return ''
  if (value.length <= length) return value
  return value.substring(0, length) + suffix
})

// 首字母大写
Vue.filter('capitalize', (value) => {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
})

// 全小写
Vue.filter('lowercase', (value) => {
  if (!value) return ''
  return value.toLowerCase()
})

// 全大写
Vue.filter('uppercase', (value) => {
  if (!value) return ''
  return value.toUpperCase()
})

// 去除空格
Vue.filter('trim', (value) => {
  if (!value) return ''
  return value.trim()
})

// JSON格式化
Vue.filter('json', (value, indent = 2) => {
  return format.formatJSON(value, indent)
})

// 布尔值转换
Vue.filter('boolean', (value, trueText = '是', falseText = '否') => {
  return value ? trueText : falseText
})

// 空值处理
Vue.filter('defaultEmpty', (value, defaultValue = '-') => {
  return value === null || value === undefined || value === '' ? defaultValue : value
})